<template>
  <div class="left-list">
    <leftTop></leftTop>
    <leftCenter></leftCenter>
    <leftBottom></leftBottom>
  </div>
</template>
<script>
import wgEchart from "@/components/wgEchart/wgEchart.vue";
import leftTop from "@/pages/patrolScreen/components/left/left-top.vue";
import leftCenter from "@/pages/patrolScreen/components/left/left-center.vue";
import leftBottom from "@/pages/patrolScreen/components/left/left-bottom.vue";
export default {
  name: "index",
  components: {
    wgEchart,
    leftTop,
    leftCenter,
    leftBottom
  },
  data() {
    return {
      optionsOne: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 1048, name: "Search Engine" },
              { value: 735, name: "Direct" },
              { value: 580, name: "Email" },
              { value: 484, name: "Union Ads" },
              { value: 300, name: "Video Ads" },
            ],
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.left-list {
  width: 1482px;
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/left/index.vue